var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.phase)?_c('span',{class:_vm.classAttribute,style:(_vm.styleAttribute),domProps:{"textContent":_vm._s(_vm.phase.name)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }